import React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { ReactSVG } from 'react-svg';

const SidebarLink = ({ 
    icon, 
    text, 
    isSelectorScreen, 
    isCurrentLevel, 
    onLevelClick, 
    onViewClick,
    active, // Destructure active prop to prevent it from being passed to NavLink
    ...props 
}) => {
    if (isSelectorScreen) {
        return (
            <SelectorWrapper>
                <ViewTab
                    className="h6"
                    isVisible={isCurrentLevel}
                    onClick={(e) => {
                        e.stopPropagation();
                        onViewClick && onViewClick();
                    }}
                >
                    View
                </ViewTab>
                <SelectorItem className="h6" onClick={() => onLevelClick && onLevelClick()}>
                    {icon && (
                        <Icon>
                            <ReactSVG src={icon}/>
                        </Icon>
                    )}
                    {text && (
                        <Text>{text}</Text>
                    )}
                </SelectorItem>
            </SelectorWrapper>
        );
    }

    return (
        <SelectorWrapper>
            <StyledLink className="h6" {...props} text={text}>
                {icon && (
                    <Icon>
                        <ReactSVG src={icon}/>
                    </Icon>
                )}
                {text && (
                    <Text>{text}</Text>
                )}
            </StyledLink>
        </SelectorWrapper>
    );
};

export default SidebarLink;

const Icon = styled.span`
    flex: 0 0 auto;
    
    svg {
        height: 4.8rem;
        width: auto;
        
        fill: currentColor;
    }
`;

const Text = styled.span`
    flex: 1 1 auto;
`;

const baseSidebarItemStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 2rem 2.5rem;
    color: white;
    background-color: ${props => props.theme.primary_color};
    border-top: 0.2rem solid ${props => props.theme.primary_color_highlight};
    transition: all .3s;
    
    &:hover {
        background-color: ${props => props.theme.primary_color_mid};
    }

    &.active {
        background-color: ${props => props.theme.primary_color_mid};
    }
`;

const StyledLink = styled(NavLink)`
    ${baseSidebarItemStyles}
`;

const SelectorWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 10rem;
`;

const SelectorItem = styled.div`
    ${baseSidebarItemStyles}
    cursor: pointer;
    position: relative;
    z-index: 2;
`;

const ViewTab = styled.button`
    position: absolute;
    z-index: 1;
    left: 100%;
    top: 0;
    height: 100%;
    padding: 0 2rem;
    color: white;
    background-color: ${props => props.theme.primary_color};
    border: none;
    border-left: 0.2rem solid ${props => props.theme.primary_color_highlight};
    transform: ${props => props.isVisible ? 'translateX(0)' : 'translateX(-100%)'};
    transition: all .3s;
    cursor: pointer;
    
    &:hover {
        background-color: ${props => props.theme.secondary_color};
    }
`;
